import {useNavigate, useParams} from 'react-router-dom';
import {useFetch} from '../../hooks/useFetch';
import LoadingContent from '../../components/LoadingContent';
import {Box, Container} from '@mui/material';
import {useTheme} from '@emotion/react';
import {useFormik} from 'formik';
import {useState} from 'react';
import useHandleErrors from '../../hooks/useHandleErrors';
import MuxPlayer from '@mux/mux-player-react';
import {useAuth} from '../../context/AuthContext';
import InfoMeeting from './components/InfoMeeting';

export default () => {
    const params = useParams();
    const {user} = useAuth();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);
    const {data, error, mutate, isLoading} = useFetch(`/booking/${params.id}`);
    useHandleErrors(error);
    const [inCall, setInCall] = useState(false);

    if (isLoading) return <LoadingContent />;
    if (error) return <LoadingContent />;

    const {meeting, meeting_scheduled, schedule, chosen, datetime, id} = data;
   
    return (
        <Box sx={{backgroundColor: 'black', height: '100%', py: 2}}>
            <Container maxWidth="lg" sx={{height: '100%'}}>
                <InfoMeeting inCall={inCall} setInCall={setInCall} />

                {inCall && (
                    <MuxPlayer
                        autoPlay={true}
                        title={meeting.title}
                        streamType="live"
                        playbackId={meeting_scheduled.playback_ids}
                        metadata={{
                            video_id: data.id,
                            vide_title: meeting.title,
                            view_user_id: user.id,
                        }}
                        style={{width: '100%', height: 'auto'}}
                    />
                )}
            </Container>
        </Box>
    );
};
